declare global {
  interface Window {
    _hmt?: any[]
  }
}

export function initBaiduAnalytics(hmId?: string) {
  if (!hmId) return
  if (!window._hmt) window._hmt = []
  const script = document.createElement('script')
  script.src = `https://hm.baidu.com/hm.js?${hmId}`
  document.head.appendChild(script)
}

export function trackPv(path: string) {
  if (!path) return
  window._hmt?.push(['_trackPageview', path])
}

export function trackStay(startTs: number, path: string) {
  if (!startTs || !path) return
  const duration = Date.now() - startTs
  // 注意：该事件会被视作互动，可能影响跳出率
  window._hmt?.push(['_trackEvent', 'stay', path, String(duration)])
}

